import * as S from "./styled";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import axiosInstance from "services/axiosInstance";
import { NumericFormat } from "react-number-format";
/**
 * Components
 */
import LayoutWithList from "../../../LayoutModal/WithList";
import ActionButton from "../../../Button/ActionButton";
import Loading from "../../../../components/Loading";
/**
 * hooks
 */
import apiRequest from "../../../../hooks/apiRequest";
import { useEffect } from "react";
import useLoading from "../../../../hooks/useLoading";
/**
 * Interfaces
 */
import { Inputs } from "Interfaces/ISensitivity";
import { IUpdate } from "Interfaces/IModalUpdate";

export default function Update({
  isOpenModalUpdate,
  setModalClose,
  updateList,
  selectedUrlId,
}: IUpdate) {
  const {
    register,
    handleSubmit: handleFormSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm<Inputs>();

  const { isLoading, startLoading, stopLoading } = useLoading();

  const fetchData = async () => {
    startLoading();
    try {
      const response = await axiosInstance.get(
        `sensitivity/${selectedUrlId}`
      );

      const addressData = response.data;
      for (const key in addressData) {
        setValue(key as keyof Inputs, addressData[key]);
      }
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    if (selectedUrlId !== null) {
      fetchData();
    }
  }, [selectedUrlId]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {
      const response = await apiRequest(
        `sensitivity/${selectedUrlId}`,
        "PUT",
        data
      );
      if (response.status === 200) {
        alert("Sensibilidades atualizada com sucesso!");
        updateList();
        setModalClose();
      }
    } catch (error: any) {
      alert(error.message || "Ocorreu um erro ao criar o fornecedor.");
    } finally {
      stopLoading();
    }
  };

  if (isOpenModalUpdate) {
    return (
      <LayoutWithList
        title="Atualizar Sensibilidade"
        subTitle="Atualize as informações da sensibilidade em sua base de dados."
        setModalClose={setModalClose}
      >
        {isLoading ? (
          <Loading />
        ) : (
          <S.Container>
            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>
                  Sensibilidade
                  <span>*</span>
                </S.Label>
                <S.Input
                  placeholder="Informe a sensibilidade"
                  type="text"
                  {...register("sensitivity", { required: true })}
                />
                {errors.sensitivity && (
                  <S.InforErro>Campo Obrigatório</S.InforErro>
                )}
              </S.FormInput>

              <S.FormInput>
                <S.Label>Porcentagem %</S.Label>
                <Controller
                  name="percentage"
                  control={control}
                  render={({ field: { onChange, value, ref } }) => (
                    <NumericFormat
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={2}
                      fixedDecimalScale={true}
                      placeholder="0,00 %"
                      suffix=" %"
                      value={value}
                      onValueChange={(values) => {
                        const purchaseValue = values.floatValue ?? 0;
                        onChange(purchaseValue);
                      }}
                      getInputRef={ref}
                    />
                  )}
                />
              </S.FormInput>

              <S.ContentButton>
                <ActionButton
                  name="Atualizar"
                  onClick={handleFormSubmit(onSubmit)}
                />
              </S.ContentButton>
            </S.SeparateDiv>
          </S.Container>
        )}
      </LayoutWithList>
    );
  }
  return null;
}
